import { AuthenticationSignIn } from "@/Shared/Authentication/CustomComponents/AuthenticationSignIn";
import { BookShipmentAuthenticationPane } from "../../CustomComponents/Internal/bookShipmentAuthenticationPane";
import type { SignInPaneProps } from "./AuthenticateForQuotesDialogBody";

export function SignInPane(props: SignInPaneProps) {
  const { onCreateAccountInstead } = props;

  function onForgotPassword() {
    window.open("/request-reset-password", "_new");
  }

  return (
    <BookShipmentAuthenticationPane>
      <AuthenticationSignIn
        onCreateAccountInstead={onCreateAccountInstead}
        onForgotPassword={onForgotPassword}
        onSuccess={props.onDone}
        redirectAfterSignin={false}
      />
    </BookShipmentAuthenticationPane>
  );
}
